import moment from 'moment';
import momentTz from 'moment-timezone';
import TIME_ZONES from '../../config/timeZones';
import VIDABOO_CONSTANTS from '../../config/consts';

const service = {};
const privateState = {};

// service.getDayStr = (time) => {
//   return moment(time).format('ddd, MMM Do');
// };
// service.getYearStr = (time) => {
//   return moment(time).format('YYYY');
// };
// service.getHourStr = (time, timeFormat) => {
//   const timeFormatStr = service.getTimeFormatStr(timeFormat);

//   return moment(time).format(timeFormatStr);
// };

service.getTimeZoneSpecficDayStr = (time, timeZone, timeFormat) => {
  const _timeZone = timeZone ?? service.generateGuessedTimezone();
  if (timeFormat) return moment(time).tz(_timeZone).format(timeFormat);
  else return moment(time).tz(_timeZone).format('ddd, MMM Do');
};

service.getTimeZoneSpecficYearStr = (time, timeZone) => {
  const _timeZone = timeZone ?? service.generateGuessedTimezone();
  return moment(time).tz(_timeZone).format('YYYY');
};

service.getTimeZoneSpecficHourStr = (time, timeFormat, timeZone) => {
  const _timeZone = timeZone ?? service.generateGuessedTimezone();
  const timeFormatStr = service.getTimeFormatStr(timeFormat);
  return moment(time).tz(_timeZone).format(timeFormatStr);
};

service.generateGoogleLink = (
  startTime,
  endTime,
  title,
  description,
  location,
) => {
  const startTimeGoogle =
    moment(startTime).utc().format('YYYYMMDDTHHmmss') + 'Z';
  const endTimeGoogle = moment(endTime).utc().format('YYYYMMDDTHHmmss') + 'Z';
  return `http://www.google.com/calendar/event?action=TEMPLATE&dates=${startTimeGoogle}%2F${endTimeGoogle}&text=${title}&location=${location}&details=${description}`;
};

service.generateOutlookLink = (
  startTime,
  endTime,
  title,
  description,
  location,
) => {
  const startTimeOutlook = moment(startTime).utc().format('YYYYMMDDTHHmmss');
  const endTimeOutlook = moment(endTime).utc().format('YYYYMMDDTHHmmss');
  return `https://outlook.live.com/owa/?path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${startTimeOutlook}&enddt=${endTimeOutlook}&subject=${title}&body=${description}&location=${location}`;
};

service.generateYahooLink = (
  startTime,
  endTime,
  title,
  description,
  location,
) => {
  const startTimeYahoo = moment(startTime).utc().format('YYYYMMDDTHHmmss');
  const endTimeYahoo = moment(endTime).utc().format('YYYYMMDDTHHmmss');
  return `https://calendar.yahoo.com/?v=60&title=$${title}&st=${startTimeYahoo}&et=${endTimeYahoo}&desc=${description}&in_loc=${location}
 `;
};

service.generateGuessedTimezone = () => {
  const guessedTimeZone = momentTz.tz.guess();
  return guessedTimeZone || VIDABOO_CONSTANTS.DEFAULT_TIME_ZONE;
};
service.getTimezonesList = () => {
  if (privateState.tzList) return privateState.tzList;
  else privateState.generateTimezonesList();
  // console.debug(privateState.tzList);
  return privateState.tzList;
};

service.getTimeZones = () => {
  var timeZones = momentTz.tz.names();
  var offsetTmz = [];
  for (let index in timeZones) {
    offsetTmz.push({
      key: timeZones[index],
      value:
        ' (GMT' +
        moment.tz(timeZones[index]).format('Z') +
        ') ' +
        timeZones[index],
    });
  }
  return offsetTmz;
};
privateState.generateTimezonesList = () => {
  if (!privateState.tzHash) privateState.generateTimezonesHash();
  privateState.tzList = [];
  Object.keys(privateState.tzHash).forEach((tz) => {
    privateState.tzList.push({
      key: tz,
      label: '(GMT' + momentTz.tz(tz).format('Z') + ') ' + tz,
    });
  });
};
privateState.generateTimezonesHash = () => {
  privateState.tzHash = {};
  TIME_ZONES.forEach((tz) => {
    Object.values(tz.utc).forEach((tzName) => {
      privateState.tzHash[tzName] =
        '(GMT' + momentTz.tz(tzName).format('Z') + ') ' + tzName;
    });
  });
};

service.getTimeAfterTzShift = (time, dstTimezone, srcTimezone) => {
  if (!srcTimezone) srcTimezone = service.generateGuessedTimezone();
  const now = moment.utc();
  // get the zone offsets for this time, in minutes
  const srcTzOffset = moment.tz.zone(srcTimezone).utcOffset(now);
  const dstTzOffset = moment.tz.zone(dstTimezone).utcOffset(now);
  const diff = dstTzOffset - srcTzOffset;
  const newTime = time + diff * 60 * 1000;
  return newTime;
};
service.getMinutesFromDayStart = (date) => {
  return date.minutes() + date.hour() * 60;
};
service.generateTimeIntervals = (
  desiredStartTime,
  interval,
  period,
  timeFormat,
  desiredEndTime,
) => {
  if (!interval) interval = VIDABOO_CONSTANTS.DEFAULT_TIME_SLOT_JUMP; // default for protection.
  const periodsInADay = moment.duration(1, 'day').as(period);
  const timeFormatStr = service.getTimeFormatStr(timeFormat);
  const timeLabels = [];
  const startTimeMoment = moment(desiredStartTime, timeFormatStr);
  let endTimeMoment = desiredEndTime
    ? moment(desiredEndTime, timeFormatStr)
    : startTimeMoment.clone().endOf('day');

  for (let i = 0; i <= periodsInADay; i += interval) {
    startTimeMoment.add(i === 0 ? 0 : interval, period);
    if (startTimeMoment.isBefore(endTimeMoment))
      timeLabels.push(startTimeMoment.format(timeFormatStr));
  }
  endTimeMoment = getNormalizedTime(endTimeMoment);

  timeLabels.push(endTimeMoment.format(timeFormatStr));
  return timeLabels;
};
const getNormalizedTime = (momentTime) => {
  // in case we want to show a time that is in the sort of 11:59:59 ==> we'd like to show it as 12:00:00. Therefore, we add a second. Note that the end-of-day generated by moment is of that type (11:59:59.999999).
  // Make sure to use this ONLY for rendering purposes.
  // if (time.get('minutes') % 5 === 4) {
  //   time = time.add(1, 'seconds');
  // }
  return moment(Math.round(momentTime.valueOf() / 1e3) * 1e3);
};
service.getTimeFormatStr = (timeFormat) => {
  return timeFormat === VIDABOO_CONSTANTS.TIME_FORMAT.TWELVE_HOUR
    ? 'h:mm A' // don't change this unless change getHourValue
    : 'HH:mm';
};
service.generateDaysArray = (year, month, weekStartDay) => {
  const arr = [];
  const givenDate = moment(year + '-' + month, 'YYYY-MM');
  const days = givenDate.daysInMonth();
  const firstDayOfMonth = givenDate.startOf('month');
  const firstDayOfWeek = firstDayOfMonth.clone().startOf('week');
  if (weekStartDay === 'MONDAY') firstDayOfWeek.add(1, 'day');
  let offset = firstDayOfMonth.diff(firstDayOfWeek, 'days');
  if (offset < 0) offset += 7; // in case first day is monday and first day of month is Sunday for example. In this case, offset will be -1
  for (let i = 1; i <= offset; i++) {
    arr.push(' ');
  }
  // Math.ceil((givenDate.date() + offset) / 7)
  for (let i = 1; i <= days; i++) {
    arr.push(i);
  }
  return arr;
};
service.getWeekStartEnd = (date, firstDayOfWeek, timezone) => {
  if (!timezone) timezone = date.tz();
  const startOfWeek = date.clone().tz(timezone).startOf('week');
  if (
    firstDayOfWeek === VIDABOO_CONSTANTS.WEEKDAYS_ENUM.MONDAY &&
    startOfWeek.day() === 0
  ) {
    startOfWeek.add(1, 'days');
    if (startOfWeek.isAfter(date)) startOfWeek.add(-7, 'days');
  } else if (
    firstDayOfWeek === VIDABOO_CONSTANTS.WEEKDAYS_ENUM.SUNDAY &&
    startOfWeek.day() === 1
  ) {
    startOfWeek.add(-1, 'days');
  }
  return [startOfWeek, startOfWeek.clone().add(7, 'days')];
};

service.compareToValidRanges = (
  time,
  date,
  validTimeRanges,
  timeFormat,
  selectedTimezone,
  mentorTimeZone,
) => {
  // console.debug(time, date, validTimeRanges, timeFormat, 'compareToValidRanges');
  let currentTimezone = selectedTimezone ?? service.generateGuessedTimezone();
  if (!validTimeRanges) return true;
  let isWithinValidRange = false;
  // Not using .add() here: When DST change happens on the same day, adding hours to midnight causes issues.
  // Using .hour() and .minute() setters triggers moment to recalculate the UTC offset correctly.
  let selectedDateTime = moment(date)
    .tz(currentTimezone)
    .startOf('day')
    // .add({
    //   hour: service.getHourValue(time),
    //   minute: service.getMinValue(time),
    // });
    .hour(service.getHourValue(time))
    .minute(service.getMinValue(time));
  const mentorCurrentDateTime = moment(selectedDateTime).tz(mentorTimeZone);
  const dayOfWeekGivenDay = Object.keys(VIDABOO_CONSTANTS.WEEKDAYS_ENUM)[
    mentorCurrentDateTime.day()
  ];
  const validTimeRange = validTimeRanges[dayOfWeekGivenDay] || [];

  validTimeRange.forEach((timeRange) => {
    // Not using .add() here: When DST change happens on the same day, adding hours to midnight causes issues.
    // Using .hour() and .minute() setters triggers moment to recalculate the UTC offset correctly.
    let fromDateTime = moment(mentorCurrentDateTime)
      .startOf('day')
      //   .add({
      //   hour: service.getHourValue(time),
      //   minute: service.getMinValue(time),
      // });
      .hour(
        parseInt(
          moment(timeRange.fromDateTime).tz(mentorTimeZone).format('HH'),
        ),
      )
      .minute(
        parseInt(
          moment(timeRange.fromDateTime).tz(mentorTimeZone).format('mm'),
        ),
      );
    let toDateTime = moment(mentorCurrentDateTime)
      // .startOf('day')
      //  .add({
      //   hour: moment(timeRange.toDateTime).tz(mentorTimeZone).format('HH'),
      //   minute: moment(timeRange.toDateTime).tz(mentorTimeZone).format('mm'),
      // });
      .hour(
        parseInt(moment(timeRange.toDateTime).tz(mentorTimeZone).format('HH')),
      )
      .minute(
        parseInt(moment(timeRange.toDateTime).tz(mentorTimeZone).format('mm')),
      );
    fromDateTime = fromDateTime.tz(currentTimezone);
    toDateTime = toDateTime.tz(currentTimezone);
    if (
      selectedDateTime.isSameOrAfter(fromDateTime) &&
      selectedDateTime.isSameOrBefore(toDateTime)
    ) {
      isWithinValidRange = true;
    }
  });

  return isWithinValidRange;
};

service.compareTimeToMinDate = (
  time,
  date,
  minDate,
  timeFormat,
  selectedTimezone,
  // mentorTimeZone,
) => {
  // returns true if time is same or after minDate
  if (!minDate) return true;
  let currentTimezone = selectedTimezone ?? service.generateGuessedTimezone();
  const timeFormatStr = service.getTimeFormatStr(timeFormat);
  let currentPickerTime = moment(date)
    .tz(currentTimezone)
    .startOf('day')
    .add({
      hour: service.getHourValue(time),
      minute: service.getMinValue(time),
    });
  if (currentTimezone) {
    return moment(currentPickerTime).isSameOrAfter(
      moment(minDate).tz(currentTimezone),
    );
  } else {
    return moment(date)
      .startOf('day')
      .add({
        hour: moment(time, timeFormatStr).format('HH'),
        minute: moment(time, timeFormatStr).format('mm'),
      })
      .isSameOrAfter(minDate);
  }
};

service.compareTimeToMaxDate = (
  time,
  date,
  maxDate,
  validTimeRanges,
  timeFormat,
  sessionTimeLimit,
  selectedTimezone,
  mentorTimeZone,
) => {
  // returns true if time is same or before maxDate
  let currentTimezone = selectedTimezone ?? service.generateGuessedTimezone();
  const timeFormatStr = service.getTimeFormatStr(timeFormat);
  if (!maxDate && sessionTimeLimit) {
    if (!validTimeRanges) return true;

    let selectedDateTime = moment(date)
      .tz(currentTimezone)
      .startOf('day')
      .add({
        hour: service.getHourValue(time),
        minute: service.getMinValue(time),
      });
    const mentorCurrentDateTime = moment(selectedDateTime).tz(mentorTimeZone);

    const dayOfWeekGivenDay = Object.keys(VIDABOO_CONSTANTS.WEEKDAYS_ENUM)[
      mentorCurrentDateTime.day()
    ];
    const validTimeRange = validTimeRanges[dayOfWeekGivenDay] || [];

    const isWithinValidRange = validTimeRange.find((timeRange) => {
      let minDateTime = moment(mentorCurrentDateTime)
        .startOf('day')
        .add({
          hour: moment(timeRange.fromDateTime).tz(mentorTimeZone).format('HH'),
          minute: moment(timeRange.fromDateTime)
            .tz(mentorTimeZone)
            .format('mm'),
        });
      let maxDateTime = moment(mentorCurrentDateTime)
        .startOf('day')
        .add({
          hour: moment(timeRange.toDateTime).tz(mentorTimeZone).format('HH'),
          minute: moment(timeRange.toDateTime).tz(mentorTimeZone).format('mm'),
          second: moment(timeRange.toDateTime).tz(mentorTimeZone).format('ss'),
        });

      minDateTime = minDateTime.tz(currentTimezone);
      maxDateTime = maxDateTime.tz(currentTimezone);

      return (
        selectedDateTime.valueOf() + sessionTimeLimit >=
          minDateTime.valueOf() &&
        (selectedDateTime.valueOf() + sessionTimeLimit <=
          maxDateTime.valueOf() || // To handle end of day selection case as in it we get time as 11:59:59 whereas selectedDateTime.valueOf() + sessionTimeLimit = 00:00:00
          moment(selectedDateTime.valueOf() + sessionTimeLimit).diff(
            moment(maxDateTime),
            'seconds',
          ) <= 1)
      );
    });
    if (isWithinValidRange) return true;
    return false;
  }
  const dayEndTime = moment(date).endOf('day');

  return moment(date)
    .startOf('day')
    .add({
      hour: moment(time, timeFormatStr).format('HH'),
      minute: moment(time, timeFormatStr).format('mm'),
    })
    .isSameOrBefore(dayEndTime);
};

service.compareTimeToAlreadyBookedMeetings = (
  time,
  date,
  alreadyBookedTimeRanges,
  timeFormat,
  sessionTimeLimit,
  selectedTimezone,
  // mentorTimeZone,
) => {
  if (!alreadyBookedTimeRanges || alreadyBookedTimeRanges.length === 0)
    return true;

  let currentTimezone = selectedTimezone ?? service.generateGuessedTimezone();
  const timeFormatStr = service.getTimeFormatStr(timeFormat);

  //Not using add here: When DTS change happens on the same day, adding hours to midnight causes issues. eg, DTS change on 2nd Nov 2025 in New York timezone at 2AM. add is DST aware; so, if we add 9 hrs, it only adds 9 hrs, instead 10hrs should have been added due to the shift.
  //the case where add breaks is when dst shift happens on the same day as the selected date
  let currentPickerTime = moment(date)
    .tz(currentTimezone)
    .startOf('day')
    .hour(parseInt(moment(time, timeFormatStr).format('HH')))
    .minute(parseInt(moment(time, timeFormatStr).format('mm')))
    // .add({
    //   hour: moment(time, timeFormatStr).format('HH'),
    //   minute: moment(time, timeFormatStr).format('mm'),
    // })
    .valueOf();

  const isAlreadyBooked = alreadyBookedTimeRanges.find((timeSlot) => {
    const meetingStartTime = moment(timeSlot.fromDateTime)
      .tz(currentTimezone)
      .valueOf();
    const meetingEndTime = moment(timeSlot.toDateTime)
      .tz(currentTimezone)
      .valueOf();

    // const isConflict =
    // (currentPickerTime >= meetingStartTime &&
    //   currentPickerTime < meetingEndTime) ||
    // (currentPickerTime + sessionTimeLimit > meetingStartTime &&
    //   currentPickerTime + sessionTimeLimit < meetingEndTime) ||
    // (currentPickerTime < meetingStartTime &&
    //   currentPickerTime + sessionTimeLimit > meetingEndTime);
    const isConflict = !(
      currentPickerTime + sessionTimeLimit <= meetingStartTime ||
      currentPickerTime >= meetingEndTime
    );

    return isConflict;
  });

  if (isAlreadyBooked) {
    return false;
  }
  return true;
};

service.isTimeValid = (
  time,
  date,
  alreadyBookedTimeRanges,
  validTimeRanges,
  timeFormat,
  sessionTimeLimit,
  maxDate,
  selectedTimezone,
  mentorTimeZone,
  minDate,
) => {
  return (
    service.compareToValidRanges(
      time,
      date,
      validTimeRanges,
      timeFormat,
      selectedTimezone,
      mentorTimeZone,
    ) &&
    service.compareTimeToMinDate(
      time,
      date,
      minDate,
      timeFormat,
      selectedTimezone,
      mentorTimeZone,
    ) &&
    service.compareTimeToMaxDate(
      time,
      date,
      maxDate,
      validTimeRanges,
      timeFormat,
      sessionTimeLimit,
      selectedTimezone,
      mentorTimeZone,
    ) &&
    service.compareTimeToAlreadyBookedMeetings(
      time,
      date,
      alreadyBookedTimeRanges,
      timeFormat,
      sessionTimeLimit,
      selectedTimezone,
      mentorTimeZone,
    )
  );
};

service.isValidDay = (
  date,
  alreadyBookedTimeRanges,
  scheduleSettingsDto,
  maxDate,
  timeIntervals,
  sessionTimeLimit,
  selectedTimezone,
  disableValidDateRanges,
  minDate,
) => {
  const {timeFormat, availableTimeRangesSelector, availableTimeRanges} =
    scheduleSettingsDto;

  // const dayOfWeekGivenDay = Object.keys(VIDABOO_CONSTANTS.WEEKDAYS_ENUM)[
  //   date.day()
  // ];

  let validDateRanges = null;
  if (!disableValidDateRanges) {
    validDateRanges =
      availableTimeRangesSelector ===
      VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.SPECIFIC_TIME
        ? availableTimeRanges || {}
        : availableTimeRangesSelector ===
            VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.NO_TIME
          ? {}
          : null;

    // if (validDateRanges) {
    //   const isInAvailableDays = Object.keys(validDateRanges).find(
    //     // checking if this the given day is in the timeRanges hash
    //     (day) => day === dayOfWeekGivenDay,
    //   );
    //   if (!isInAvailableDays) {
    //     return false;
    //   }
    // }
  }

  const timesArray = service.generateTimeIntervals(
    '00:00',
    timeIntervals,
    'minutes',
    timeFormat,
  );
  const validTimeRanges = validDateRanges;
  // validDateRanges && (validDateRanges[dayOfWeekGivenDay] || []);

  let firstAvailableTimeSlot = '';
  for (let i = 0; i < timesArray.length; i++) {
    if (
      service.isTimeValid(
        timesArray[i],
        date,
        alreadyBookedTimeRanges,
        validTimeRanges,
        timeFormat,
        sessionTimeLimit,
        maxDate,
        selectedTimezone,
        scheduleSettingsDto.timezone,
        minDate,
      )
    ) {
      firstAvailableTimeSlot = timesArray[i];
      break;
    }
  }

  return firstAvailableTimeSlot;
};

service.bookedRangesToDateWiseRecords = (
  bookedTimeRecordsByDate,
  meetingDetails,
  timezone,
) => {
  // Use the viewer's selected timezone to compute the day key so that bookings
  // whose start time crosses a day boundary (e.g. 9 AM IST = 11:30 PM NY) are
  // stored under the correct day in the viewer's timezone. Without this, the
  // slot picker looks up day 13 (NY) but the booking is stored under day 14
  // (browser IST), causing the slot to appear free when it is actually booked.
  const tz = timezone || service.generateGuessedTimezone();
  const startDate = moment(meetingDetails?.fromDateTime)
    .tz(tz)
    .startOf('day')
    .get('date');
  if (!bookedTimeRecordsByDate.get(startDate)) {
    bookedTimeRecordsByDate.set(startDate, [meetingDetails]);
  } else {
    let currentDurationObj = bookedTimeRecordsByDate.get(startDate);
    bookedTimeRecordsByDate.set(startDate, [
      ...currentDurationObj,
      meetingDetails,
    ]);
  }
  return bookedTimeRecordsByDate;
};

service.getLocaleSpecificMomentObj = (time, locale = 'en', format) => {
  if (format) return moment(time, format).locale(locale);
  else return moment(time).locale(locale);
};

service.getHourValue = (time) => {
  //This method returns the hour value in 24 hr format
  //Accepted formats for time -> 12:00 AM, 12:15 AM, 01:00 AM, ... 12:00 PM,
  const timeHourAndMin = time.split(':');
  if (timeHourAndMin[1].split(' ')[1] === 'AM') {
    if (Number(timeHourAndMin[0]) === 12) {
      return 0;
    } else return Number(timeHourAndMin[0]);
  } else if (timeHourAndMin[1].split(' ')[1] === 'PM') {
    const hoursCount = Number(timeHourAndMin[0]) === 12 ? 0 : 12;
    return Number(timeHourAndMin[0]) + hoursCount;
  } else return Number(timeHourAndMin[0]);
};

service.getMinValue = (time) => {
  //This method returns the minute value
  //Accepted formats for time -> 12:00 AM, 12:15 AM, 01:00 AM, ... 12:00 PM,
  return Number(time.split(':')[1].split(' ')[0]);
};

service.getLocaleSpecificWeekDays = async (
  locale = 'en',
  weekStartDay = 'SUNDAY',
) => {
  let dayNames = [];
  await import('moment/min/locales.min');
  const weekDays = moment().locale(locale).localeData().weekdays();
  dayNames =
    weekStartDay === 'SUNDAY'
      ? [0, 1, 2, 3, 4, 5, 6].map((day) => weekDays[day])
      : [1, 2, 3, 4, 5, 6, 0].map((day) => weekDays[day]);
  return dayNames;
};

service.getLocaleSpecificMonths = (locale = 'en') => {
  return moment().locale(locale).localeData().months();
};
service.getFullNameAndEmail = (exBfiDto, currentUserId) => {
  let nameAndEmail = '';
  const recipients = exBfiDto.bookingFlowInstanceDto.recipients.filter(
    (recipient) => recipient.userId !== currentUserId,
  );
  if (recipients?.length) {
    nameAndEmail = recipients[0].displayName
      ? recipients[0].displayName + ' --- ' + recipients[0].email
      : recipients[0].email;
  } else {
    nameAndEmail = exBfiDto.bookingFlowInstanceDto.requester.displayName
      ? exBfiDto.bookingFlowInstanceDto.requester.displayName +
        ' --- ' +
        exBfiDto.bookingFlowInstanceDto.requester.email
      : exBfiDto.bookingFlowInstanceDto.requester.email;
  }
  return nameAndEmail;
};
service.getAttendeesEmail = (exBfiDto, currentUserId) => {
  let attendeesEmail = [];
  exBfiDto.bookingFlowInstanceDto.recipients?.forEach((recipient) => {
    if (recipient.userId !== currentUserId) {
      attendeesEmail.push({email: recipient.email});
    }
  });
  if (exBfiDto.bookingFlowInstanceDto.requester.userId !== currentUserId) {
    attendeesEmail.push({
      email: exBfiDto.bookingFlowInstanceDto.requester.email,
    });
  }
  return attendeesEmail;
};
service.getBookingOptionByStartTime = (startTime, bookingFlowInstanceDto) => {
  return Object.values(bookingFlowInstanceDto.bookingOptions).find(
    (bookingOption) => {
      return bookingOption.rangeStartTimeSender === startTime;
    },
  );
};
service.createNewBookingOption = (
  requestedStartTime,
  sessionTimeLimit,
  startTimeSlotJumps,
  timezone,
) => {
  // this method is used to create a new bookingOption in the first possible time slot after the requestedStartTime.
  const now = moment().tz(timezone);
  const currentMinutes = now.format('mm');
  let meetingStartTime = moment(requestedStartTime).tz(timezone).format('mm');

  if (requestedStartTime <= now.valueOf()) {
    meetingStartTime =
      startTimeSlotJumps *
      (Math.floor(currentMinutes / startTimeSlotJumps) + 2);
  }

  const meetingStartTimeSlot = moment(requestedStartTime)
    .startOf('hour')
    .tz(timezone)
    .add(meetingStartTime, 'minutes')
    .valueOf();
  const meetingEndTimeSlot = moment(meetingStartTimeSlot)
    .tz(timezone)
    .add(sessionTimeLimit, 'minutes')
    .valueOf();
  const newBookingOption = {
    rangeStartTimeSender: meetingStartTimeSlot,
    rangeEndTimeSender: meetingEndTimeSlot,
  };
  return newBookingOption;
};

service.getIsMeetingPassed = (exBfiDto) => {
  const now = new Date().getTime();
  if (exBfiDto.bookingFlowInstanceDto.confirmedSessionEndTime) {
    return now > exBfiDto.bookingFlowInstanceDto.confirmedSessionEndTime;
  } else {
    let proposalOptionsPassed = true,
      bookingOptionsPassed = true;
    exBfiDto.bookingFlowInstanceDto.proposals?.forEach((proposal) => {
      if (now < proposal.rangeEndTimeSender) {
        proposalOptionsPassed = false;
      }
    });
    Object.values(exBfiDto.bookingFlowInstanceDto.bookingOptions).forEach(
      (bookingOption) => {
        if (now <= bookingOption.rangeEndTimeSender) {
          bookingOptionsPassed = false;
        }
      },
    );
    return bookingOptionsPassed && proposalOptionsPassed;
  }
};

service.getBfiExpiryTime = (exBfiDto) => {
  let bfiExpiryTime;
  const bookingFlowInstanceDto = exBfiDto?.bookingFlowInstanceDto;
  if (
    bookingFlowInstanceDto &&
    !service.getIsMeetingPassed({
      bookingFlowInstanceDto,
    })
  ) {
    const now = new Date().getTime();
    if (bookingFlowInstanceDto.confirmedSessionEndTime) {
      bfiExpiryTime = bookingFlowInstanceDto.confirmedSessionEndTime;
    } else {
      // Find the maximum rangeEndTimeSender from proposals that's still in the future
      bookingFlowInstanceDto.proposals?.forEach((proposal) => {
        if (now < proposal.rangeEndTimeSender) {
          bfiExpiryTime = Math.max(
            bfiExpiryTime ?? 0,
            proposal.rangeEndTimeSender,
          );
        }
      });
      // If no valid proposals, check bookingOptions for the maximum rangeEndTimeSender
      Object.values(bookingFlowInstanceDto.bookingOptions).forEach(
        (bookingOption) => {
          if (now <= bookingOption.rangeEndTimeSender) {
            bfiExpiryTime = Math.max(
              bfiExpiryTime ?? 0,
              bookingOption.rangeEndTimeSender,
            );
          }
        },
      );
    }
  }
  return bfiExpiryTime;
};

service.meetingStatuses = {
  CONFIRMED: {
    status: VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.CONFIRMED,
    color: '#11D200',
    title: 'Confirmed',
    description: 'This meeting was accepted',
  },
  CREATED: {
    status: VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.CREATED,
    color: '#2961FA',
    title: 'Pending, their turn',
    description: "Waiting for your peer's response.",
  },
  PENDING: {
    status: VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.PENDING,
    color: '#F7B408',
    title: 'Pending, my turn',
    description: 'Waiting for your response.',
  },
  CREATE_OR_CHANGE: {
    status: 'CREATE-OR-CHANGE',
    color: '#2d2756',
    title: 'Create or change',
    description: 'Creating or modifying a meeting',
  },
  OVERDUE: {
    status: VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.OVERDUE,
    color: '#DFDFDF',
    title: 'Overdue',
    description: 'This meeting is in the past',
  },
  CANCELLED: {
    status: VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.CANCELLED,
    color: '#808080',
    title: 'Cancelled',
    description: 'This meeting was cancelled',
  },
  DECLINED: {
    status: VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.DECLINED,
    color: '#FF6262',
    title: 'Declined',
    description: 'This meeting request was rejected',
  },
};

service.getHourMaskData = (
  start,
  end,
  timeRanges,
  timezone,
  rangesTimezone,
) => {
  // timeRanges = {
  //   SUNDAY: [
  //     {fromDateTime: 1622240000000, toDateTime: 1622243600000}, // 2021-06-09T00:00:00.000Z - 2021-06-09T01:00:00.000Z
  //     {fromDateTime: 1622252000000, toDateTime: 1622255600000}, // 2021-06-09T02:00:00.000Z - 2021-06-09T03:00:00.000Z
  //   ],

  //   MONDAY: [
  //     {fromDateTime: 1622326400000, toDateTime: 1622329999999}, // 2021-06-10T00:00:
  //   ],
  // };

  const startOfWeek = moment
    .tz(start, rangesTimezone)
    .startOf('week')
    .valueOf();
  return Object.entries(timeRanges).flatMap(([day, ranges]) => {
    const startOfDay = moment
      .tz(startOfWeek, rangesTimezone)
      .day(day)
      .startOf('day')
      .valueOf();

    const rangeArr = ranges
      .map((range) => {
        // Create a Moment.js object using the startDateTime value and the desired timezone
        const fromDateTz = moment.tz(range.fromDateTime, rangesTimezone);
        const fromDateMsFromStartOfDay =
          fromDateTz.valueOf() - fromDateTz.startOf('day').valueOf();
        let fromTime = fromDateMsFromStartOfDay + startOfDay;

        const toDateTz = moment.tz(range.toDateTime, rangesTimezone);
        const toDateMsFromStartOfDay =
          toDateTz.valueOf() - toDateTz.startOf('day').valueOf();
        let toTime = toDateMsFromStartOfDay + startOfDay;
        if (fromTime < start && toTime >= start) {
          fromTime = start;
        }
        if (toTime > end && fromTime <= end) {
          toTime = end;
        }
        if (fromTime >= start && toTime <= end) {
          const lengthInMinutes = moment
            .duration(toTime - fromTime)
            .asMinutes();
          const diffFromStartInMinutes = (fromTime - start) / (1000 * 60);

          return {
            fromTime: fromTime,
            toTime: toTime,
            lengthInMinutes: lengthInMinutes,
            diffFromStartInMinutes: diffFromStartInMinutes,
          };
        }
      })
      .filter((range) => range !== undefined);
    return rangeArr;
  });
};

service.getMinDate = (minutes, selectedTimezone) => {
  //This method returns the minimum date (moment obj)
  //minutes : will be any value from VIDABOO_CONSTANTS.MINIMUM_TIME_BEFORE_BOOKING_IN_MIN
  if (!selectedTimezone) {
    selectedTimezone = service.generateGuessedTimezone();
  }
  let minDate = moment().tz(selectedTimezone);
  //Handle next day
  if (
    minutes === VIDABOO_CONSTANTS.MINIMUM_TIME_BEFORE_BOOKING_IN_MIN.NEXT_DAY
  ) {
    minDate = moment().tz(selectedTimezone).startOf('day').add({
      day: 1,
    });
  } else {
    minDate = moment().tz(selectedTimezone).add({
      minutes,
    });
  }
  return minDate;
};

service.getMeetingCompType = (exBfiDto = {}, userId = '') => {
  if (
    exBfiDto.bookingFlowInstanceDto?.status &&
    exBfiDto.bookingFlowInstanceDto?.recipients &&
    userId.length
  ) {
    const meetingStatus = exBfiDto.bookingFlowInstanceDto.status;
    const currentUserIsRequester =
      userId === exBfiDto.bookingFlowInstanceDto.requester.userId;
    const recipients = [...exBfiDto.bookingFlowInstanceDto.recipients];
    const currentUserMeetingObj =
      recipients.find((recipient) => recipient.userId === userId) ?? {};
    const isOverdue = service.getIsMeetingPassed(exBfiDto);
    if (isOverdue) {
      return VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.OVERDUE;
    }
    if (meetingStatus === VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.CREATED) {
      if (currentUserIsRequester) {
        return VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.CREATED;
      } else {
        if (
          currentUserMeetingObj.status ===
          VIDABOO_CONSTANTS.BOOKING_FLOW_USER_STATES.CREATED
        ) {
          return VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.PENDING;
        } else {
          return currentUserMeetingObj.status;
        }
      }
    } else if (
      meetingStatus === VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.DECLINED
    ) {
      return VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.DECLINED;
    } else if (
      meetingStatus === VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.CONFIRMED
    ) {
      if (currentUserIsRequester) {
        return VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.CONFIRMED;
      } else {
        if (
          currentUserMeetingObj.status ===
          VIDABOO_CONSTANTS.BOOKING_FLOW_USER_STATES.CREATED
        ) {
          return VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.PENDING;
        } else {
          return currentUserMeetingObj.status;
        }
      }
    } else if (
      meetingStatus === VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.CANCELLED ||
      meetingStatus === VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.REBOOKED
    ) {
      //TODO:Jashan -> REBOOKED need to handled
      return VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.CANCELLED;
    } else if (
      meetingStatus === VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.OVERDUE
    ) {
      return VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.OVERDUE;
    }
  }
};

service.getSchedulingCancelApiType = (exBfiDto = {}, userId = '') => {
  const currentUserIsRequester =
    userId === exBfiDto.bookingFlowInstanceDto.requester.userId;
  const recipients = [...exBfiDto.bookingFlowInstanceDto.recipients];
  const currentUserMeetingObj = recipients.find(
    (recipient) => recipient.userId === userId,
  );
  const shouldRunCancelFlow =
    currentUserIsRequester ||
    (currentUserMeetingObj &&
      currentUserMeetingObj.status ===
        VIDABOO_CONSTANTS.BOOKING_FLOW_USER_STATES.CONFIRMED);
  if (shouldRunCancelFlow) return VIDABOO_CONSTANTS.SCHEDULING_API_TYPES.CANCEL;
  else return VIDABOO_CONSTANTS.SCHEDULING_API_TYPES.DECLINE;
};

service.getSchedulingRebookApiType = (exBfiDto = {}, userId = '') => {
  const currentUserIsRequester =
    userId === exBfiDto.bookingFlowInstanceDto.requester.userId;
  if (currentUserIsRequester) {
    if (
      exBfiDto.bookingFlowInstanceDto.status ===
        VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.CREATED ||
      exBfiDto.bookingFlowInstanceDto.status ===
        VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.CONFIRMED
    ) {
      return VIDABOO_CONSTANTS.SCHEDULING_API_TYPES.RESCHEDULE_BY_REQUESTER;
    }
  }
  return VIDABOO_CONSTANTS.SCHEDULING_API_TYPES.RESCHEDULE_BY_RECIPIENT;
};
service.getMeetingTitle = (displayName = '', sessionTemplateDto = {}) => {
  if (sessionTemplateDto.sessionTitle) {
    return sessionTemplateDto.sessionTitle;
  } else {
    return 'Meeting with ' + displayName;
  }
};
service.getExRoomMeetingStartTime = (
  flowType = '',
  extendedMeetingRoomDto = {},
) => {
  let meetingStartTime = '';
  if (flowType === VIDABOO_CONSTANTS.MEETING_ROOM_FLOW_TYPES.INSTANT) {
    const meetingRoomDto = extendedMeetingRoomDto?.meetingRoomDto ?? {};
    meetingStartTime = meetingRoomDto.createdTimeServer;
  } else if (
    flowType === VIDABOO_CONSTANTS.MEETING_ROOM_FLOW_TYPES.SCHEDULING
  ) {
    const bookingFlowInstanceDto =
      extendedMeetingRoomDto?.bookingFlowInstanceDto ?? {};
    const meetingCompType = service.getMeetingCompType(
      {bookingFlowInstanceDto},
      bookingFlowInstanceDto.mentorUserId, // we can use mentorUserId in this case because we just need to know whether the meeting is actually CANCELLED, OVERDUE ... it doesn't matter whether it is in CREATED or PENDING state for a user
    );
    if (
      [
        VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.CANCELLED,
        VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.DECLINED,
        VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.OVERDUE,
        VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.REBOOKED,
      ].includes(meetingCompType)
    ) {
      meetingStartTime = moment().subtract({day: 1}).valueOf(); // subtracting one day so that start time is in past
    } else if (
      meetingCompType ===
      VIDABOO_CONSTANTS.BOOKING_FLOW_COMPONENT_TYPES.CONFIRMED
    ) {
      // CONFIRMED
      meetingStartTime = bookingFlowInstanceDto.confirmedSessionStartTime;
    } else {
      // CREATED/PENDING
      meetingStartTime = service.getBfiExpiryTime({
        bookingFlowInstanceDto,
      });
    }
  }
  return meetingStartTime;
};
service.getExRoomMeetingEndTime = (flowType = '', meetingStartTime) => {
  let meetingEndTime = '';
  if (flowType === VIDABOO_CONSTANTS.MEETING_ROOM_FLOW_TYPES.INSTANT) {
    meetingEndTime = moment(meetingStartTime).add({hours: 3}).valueOf();
  } else if (
    flowType === VIDABOO_CONSTANTS.MEETING_ROOM_FLOW_TYPES.SCHEDULING
  ) {
    meetingEndTime = moment(meetingStartTime).add({hours: 2}).valueOf();
  }
  return meetingEndTime;
};

service.mergeAvailableTimeRanges = (availableTimeRanges) => {
  const mergedAvailableTimeRanges = {};
  const tempAvailableTimeRanges = JSON.parse(
    JSON.stringify(availableTimeRanges),
  );

  for (const day in availableTimeRanges) {
    const timeRanges = tempAvailableTimeRanges[day];
    if (!timeRanges || timeRanges.length < 1) {
      // Removing keys with no time slots
      delete tempAvailableTimeRanges[day];
    } else {
      timeRanges.sort(
        (a, b) =>
          moment(a.fromDateTime).valueOf() - moment(b.fromDateTime).valueOf(),
      );

      const mergedTimeRanges = [];
      let currentStartTime = timeRanges[0].fromDateTime;
      let currentEndTime = timeRanges[0].toDateTime;

      for (let i = 1; i < timeRanges.length; i++) {
        const nextStartTime = timeRanges[i].fromDateTime;
        const nextEndTime = timeRanges[i].toDateTime;
        if (
          currentEndTime >= nextStartTime ||
          moment(nextStartTime).diff(moment(currentEndTime), 'minutes') === 1
        ) {
          currentEndTime = Math.max(currentEndTime, nextEndTime);
        } else {
          mergedTimeRanges.push({
            fromDateTime: currentStartTime,
            toDateTime: currentEndTime,
          });
          currentStartTime = nextStartTime;
          currentEndTime = nextEndTime;
        }
      }

      mergedTimeRanges.push({
        fromDateTime: currentStartTime,
        toDateTime: currentEndTime,
      });
      mergedAvailableTimeRanges[day] = mergedTimeRanges;
    }
  }
  return mergedAvailableTimeRanges;
};

service.getDateTimeInfo = (dateTime, timezone) => {
  const momentObj = moment.tz(dateTime, timezone);
  return {
    hour: momentObj.get('hours'),
    minute: momentObj.get('minutes'),
    day: VIDABOO_CONSTANTS.WEEKDAYS_INDEX[momentObj.day()],
    date: momentObj.get('date'),
  };
};

service.getWeekDay = (day, weekStartDay) => {
  // Ensure Sunday (index 0) is treated as 7 for proper date calculation.
  let weekDay =
    day === VIDABOO_CONSTANTS.WEEKDAYS_ENUM.SUNDAY &&
    weekStartDay !== VIDABOO_CONSTANTS.WEEKDAYS_ENUM.SUNDAY
      ? 7
      : Object.values(VIDABOO_CONSTANTS.WEEKDAYS_INDEX).findIndex(
          (d) => d === day,
        );
  if (weekDay === -1) {
    weekDay = weekStartDay === VIDABOO_CONSTANTS.WEEKDAYS_ENUM.SUNDAY ? 6 : 0;
  }
  return weekDay;
};

service.getTimeOfDay = (
  isEndOfDay = false,
  timezone,
  day,
  dateTimeHourVal = 0,
  dateTimeMinVal = 0,
  dayGap = 0,
) => {
  let timeOfDay = moment()
    .tz(timezone)
    .day(day + dayGap)
    .startOf('day')
    .add({
      hours: dateTimeHourVal,
      minutes: dateTimeMinVal,
    })
    .utc()
    .valueOf();
  if (isEndOfDay) {
    timeOfDay = moment()
      .tz(timezone)
      .day(day + dayGap)
      .endOf('day')
      .utc()
      .valueOf();
  }
  return timeOfDay;
};

service.getModifiedBookingOption = (bookingOption, timezone) => {
  // Added to handle end of day case where time is 23:59:59
  const tempBookingOption = {...bookingOption};
  const {
    hour: tempBookingOptionEndTimeHour,
    minute: tempBookingOptionEndTimeMin,
  } = service.getDateTimeInfo(tempBookingOption.rangeEndTimeSender, timezone);
  if (tempBookingOptionEndTimeHour === 0 && tempBookingOptionEndTimeMin === 0) {
    tempBookingOption.rangeEndTimeSender -= 1000;
  }
  return tempBookingOption;
};

//TODO:Ilan/Jashan -> CFW-1136
// service.getHtmlString = (/* text */) => {
// let htmlString = '';
// const tempElement = document.createElement('div');
// tempElement.innerHTML = text;
// htmlString = tempElement.innerHTML;
// return htmlString;
// const regex = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;
// const unescaped = {
//   '&amp;': '&',
//   '&#38;': '&',
//   '&lt;': '<',
//   '&#60;': '<',
//   '&gt;': '>',
//   '&#62;': '>',
//   '&apos;': "'",
//   '&#39;': "'",
//   '&quot;': '"',
//   '&#34;': '"',
// };
// htmlString = text.replace(regex, (char) => {
//   return unescaped[char];
// });
// return htmlString;
// };

export default service;
